import React from "react";
import { useNavigate } from "react-router-dom";
import brandlogo from "../images/LKLogo.png";

const section = (title, children) => (
  <div style={{ marginBottom: "24px" }}>
    <h2 style={{ fontSize: "17px", fontWeight: 700, color: "#005C8E", marginBottom: "8px", borderBottom: "1px solid #E0E0E0", paddingBottom: "4px" }}>
      {title}
    </h2>
    <div style={{ fontSize: "14px", color: "#3C3C3C", lineHeight: "1.7" }}>
      {children}
    </div>
  </div>
);

export default function PrivacyNoticePage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#F5F7FA", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <div style={{ backgroundColor: "#005C8E", padding: "14px 32px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <img src={brandlogo} alt="Lauritz Knudsen" style={{ height: "40px" }} />
        <button
          onClick={() => navigate('/')}
          style={{
            background: "rgba(255,255,255,0.15)",
            border: "1px solid rgba(255,255,255,0.5)",
            color: "#fff",
            padding: "6px 18px",
            borderRadius: "20px",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          ← Back to Login
        </button>
      </div>

      {/* Document */}
      <div style={{ maxWidth: "860px", margin: "32px auto", backgroundColor: "#fff", borderRadius: "8px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)", padding: "48px 56px", flex: 1 }}>
        {/* Title */}
        <div style={{ textAlign: "center", marginBottom: "36px" }}>
          <h1 style={{ fontSize: "24px", fontWeight: 700, color: "#005C8E", margin: 0 }}>Privacy Notice</h1>
          <p style={{ fontSize: "14px", color: "#7E7E7E", marginTop: "6px" }}>Smartcomm Operate</p>
          <p style={{ fontSize: "13px", color: "#7E7E7E", marginTop: "2px" }}>Last updated: 07 April 2026 &nbsp;|&nbsp; REV 2.0</p>
        </div>

        {section("1. Scope",
          <p>
            This privacy notice applies to Smartcomm Operate (the "Service"). It explains what personal information we collect,
            how we use and share it, how long we retain it, the safeguards we apply, and how you can exercise your privacy rights.
            This notice supplements LKEA's Data Privacy Policy and Schneider Electric's global privacy statement; if there is any
            inconsistency, the corporate policies prevail.{" "}
            <a href="https://www.lk-ea.com" target="_blank" rel="noopener noreferrer" style={{ color: "#005C8E" }}>lk-ea.com</a>,{" "}
            <a href="https://www.se.com" target="_blank" rel="noopener noreferrer" style={{ color: "#005C8E" }}>se.com</a>
          </p>
        )}

        {section("2. Who is the Data Controller?",
          <>
            <p>
              <strong>Lauritz Knudsen Electrical &amp; Automation</strong> (a unit of Schneider Electric India Pvt. Ltd.) is the data
              controller for processing related to your use of this Service.{" "}
              <a href="https://www.lk-ea.com" target="_blank" rel="noopener noreferrer" style={{ color: "#005C8E" }}>lk-ea.com</a>
            </p>
            <p style={{ marginTop: "8px" }}>
              <strong>Schneider Electric Industries SAS</strong>, 35 rue Joseph Monier, 92506 Rueil-Malmaison, France, is the data
              controller for certain centralized platform activities that manage access across Schneider/LKEA services.{" "}
              <a href="https://www.lk-ea.com" target="_blank" rel="noopener noreferrer" style={{ color: "#005C8E" }}>lk-ea.com</a>
            </p>
          </>
        )}

        {section("3. Who Uses the Service",
          <p>
            The Service can be used by internal employees, ISP, system integrators, B2B customers/partners, field service teams, and
            end-consumers (as applicable to your deployment). Only users having above age of 18+ are allowed to use this application
            and enter any Personal data (if required).
          </p>
        )}

        {section("4. Information We Collect and Why We Use It",
          <>
            <p>We collect only what we need to operate the Service and support you:</p>
            <ul style={{ paddingLeft: "20px", marginTop: "8px" }}>
              <li style={{ marginBottom: "6px" }}>
                <strong>Identity &amp; contact:</strong> name, email, phone, organization, role — for registration, authentication,
                role-based access, and communications.
              </li>
              <li style={{ marginBottom: "6px" }}>
                <strong>Organization details:</strong> company name, address, administrator contact — to associate your account with
                your organization, enable access to organizational data, and meet various needs.
              </li>
              <li style={{ marginBottom: "6px" }}>
                <strong>Account &amp; access data:</strong> profile, permissions, login timestamps/session identifiers — to secure and
                operate the Service and ensure continuity.
              </li>
              <li style={{ marginBottom: "6px" }}>
                <strong>Device telemetry &amp; technical data:</strong> device/gateway/IED or any kind of data being available through
                configuration in platform — to ensure availability, troubleshoot, and improve reliability.
              </li>
              <li style={{ marginBottom: "6px" }}>
                <strong>Support interactions:</strong> tickets, attachments, and communications — to provide assistance and resolve incidents.
              </li>
              <li style={{ marginBottom: "6px" }}>
                <strong>Usage analytics (non-cookie based):</strong> event-level interactions captured in-app — to measure feature
                adoption and improve product experience.
              </li>
              <li style={{ marginBottom: "6px" }}>
                <strong>Application content:</strong> projects/configurations you create — to deliver the features you request.
              </li>
            </ul>
            <p style={{ marginTop: "10px" }}>
              If the Service interoperates with an enterprise sign-in (CIAM/SSO), the upstream identity system has its own privacy
              notice. We only consume the fields required to operate Smartcomm Operate.
            </p>
            <p style={{ marginTop: "8px" }}>
              <strong>Legal grounds (India):</strong> As the Service is offered in India, we follow the Digital Personal Data Protection
              Act, 2023 (DPDP). We provide notice in clear and plain language and rely on consent or legitimate uses as applicable.
              Data principal rights and grievance mechanisms are supported.
            </p>
          </>
        )}

        {section("5. Sign-In & Authentication",
          <p>
            Smartcomm Operate supports sign-in via LKEA internal user directory and CIAM. Centralized identity components provided by
            Schneider/LKEA enable seamless access across services as described in corporate notices.{" "}
            <a href="https://www.lk-ea.com" target="_blank" rel="noopener noreferrer" style={{ color: "#005C8E" }}>lk-ea.com</a>
          </p>
        )}

        {section("6. Cookies & Similar Technologies",
          <p>
            This application does not use cookies for tracking or profiling. If analytics become cookie-based in future, we will update
            this notice and (if enabled) point to the corporate cookie policy.{" "}
            <a href="https://www.lk-ea.com" target="_blank" rel="noopener noreferrer" style={{ color: "#005C8E" }}>lk-ea.com</a>
          </p>
        )}

        {section("7. Who We Share Information With & Where It Is Processed",
          <>
            <p>
              We share personal information with LKEA/Schneider affiliates and service providers strictly to deliver the Service under
              contracts that include appropriate privacy and security requirements. Schneider Electric uses Binding Corporate Rules (BCRs)
              and, where relevant, Standard Contractual Clauses/adequacy mechanisms to safeguard cross-border transfers. We do not sell
              or rent your personal information for monetary consideration without your permission.
            </p>
            <p style={{ marginTop: "8px", backgroundColor: "#F0F7FF", padding: "10px 14px", borderLeft: "3px solid #005C8E", borderRadius: "3px" }}>
              <strong>Note:</strong> As an India-only service, we aim to process and store data in India. If transfers occur (e.g.,
              centralized platform functions or global support), they are protected by Schneider's BCRs/SCCs as above.
            </p>
          </>
        )}

        {section("8. How We Protect Information",
          <p>
            We implement administrative, technical, and physical safeguards aligned with Schneider/LKEA policies and industry standards
            to protect against accidental or unlawful destruction, loss, alteration, or unauthorized access. While we work to protect
            your personal information, no method of transmission or storage is 100% secure.
          </p>
        )}

        {section("9. How Long We Keep Information (Retention)",
          <>
            <p>
              We retain personal information only as long as needed for the purposes described above, considering service delivery,
              security, legal obligations, and limitation periods. The following apply to Smartcomm Operate:
            </p>
            <ul style={{ paddingLeft: "20px", marginTop: "8px" }}>
              <li style={{ marginBottom: "6px" }}>
                <strong>Telemetry (raw):</strong> retained for a defined period to support reliability, debugging, and security investigations.
              </li>
              <li style={{ marginBottom: "6px" }}>
                <strong>Full account/application data:</strong> retained while your subscription is active (or from last activity, as
                configured) to ensure service continuity and compliance.
              </li>
              <li style={{ marginBottom: "6px" }}>
                <strong>After subscription ends:</strong> your account and projects remain available for a defined period to allow
                re-subscription without losing continuity. If you do not re-subscribe within this period, we will anonymize/pseudonymize
                residual data or delete it, except where retention is required by law or for the establishment, exercise, or defense
                of legal claims.
              </li>
            </ul>
          </>
        )}

        {section("10. Your Choices and Rights",
          <>
            <p>
              Under the DPDP Act, data principals have rights to access information about personal data, seek correction and erasure,
              grievance redressal, and nomination; we provide clear notice and timely responses through our established channels.
            </p>
            <ul style={{ paddingLeft: "20px", marginTop: "8px" }}>
              <li style={{ marginBottom: "6px" }}>
                We will respond to requests for exercising your rights (including access, correction, erasure, and nomination-related
                requests) within a reasonable time and in any case no later than <strong>90 days</strong> from the date we receive
                your request.
              </li>
              <li style={{ marginBottom: "6px" }}>
                We will respond to grievances raised under the DPDP Act within the period prescribed, and our process is designed to
                ensure resolution within a reasonable time, not exceeding 90 days.
              </li>
              <li style={{ marginBottom: "6px" }}>
                If you are not satisfied with our response, you may escalate the matter to the Data Protection Board, after exhausting
                the grievance redressal mechanism provided by us.
              </li>
            </ul>
            <p style={{ marginTop: "8px" }}>
              <strong>How to submit a request:</strong> Email{" "}
              <a href="mailto:cic@lkea.com" style={{ color: "#005C8E" }}>cic@lkea.com</a> for account edits/deletion; we will route
              requests to the DSAR process as needed.
            </p>
          </>
        )}

        {section("11. Contacts",
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ marginBottom: "6px" }}>
              <strong>Product support (Smartcomm Operate):</strong>{" "}
              <a href="mailto:cic@lkea.com" style={{ color: "#005C8E" }}>cic@lkea.com</a>
            </li>
            <li style={{ marginBottom: "6px" }}>
              <strong>Global privacy inquiries:</strong>{" "}
              <a href="mailto:globaldataprivacy@schneiderelectric.com" style={{ color: "#005C8E" }}>globaldataprivacy@schneiderelectric.com</a>
            </li>
            <li style={{ marginBottom: "6px" }}>
              <strong>Group Data Protection Officer (Schneider Electric):</strong>{" "}
              <a href="mailto:dpo@schneiderelectric.com" style={{ color: "#005C8E" }}>dpo@schneiderelectric.com</a>
            </li>
          </ul>
        )}

        {section("12. Changes to This Notice",
          <p>
            We may update this notice from time to time. Material changes will be communicated through the Service or by email; the
            "Last updated" date will be amended accordingly, following LKEA/Schneider practice.
          </p>
        )}

        {section("13. Consent Mechanism",
          <p>
            Consent will be provided by the application user by ticking the box that verifies if the user has read this policy document
            and agrees at the time of signing in to the application. Users have the right at all times to access this policy document
            on the portal/application and the LK-EA website.
          </p>
        )}

        {/* Appendix A */}
        <div style={{ marginBottom: "24px" }}>
          <h2 style={{ fontSize: "17px", fontWeight: 700, color: "#005C8E", marginBottom: "12px", borderBottom: "1px solid #E0E0E0", paddingBottom: "4px" }}>
            Appendix A — Data Inventory (at a glance)
          </h2>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
              <thead>
                <tr style={{ backgroundColor: "#005C8E", color: "#fff" }}>
                  <th style={{ padding: "8px 10px", textAlign: "left", fontWeight: 600 }}>Data Category</th>
                  <th style={{ padding: "8px 10px", textAlign: "left", fontWeight: 600 }}>Source</th>
                  <th style={{ padding: "8px 10px", textAlign: "left", fontWeight: 600 }}>Purpose</th>
                  <th style={{ padding: "8px 10px", textAlign: "left", fontWeight: 600 }}>Lawful Basis</th>
                </tr>
              </thead>
              <tbody>
                {[
                  ["Identity & contact (name, email, phone, org, role)", "You / Your Admin", "Account setup, authentication, support", "Consent / legitimate use (DPDP)"],
                  ["Org details (company, address, admin contact)", "You / Your Admin", "Access control, billing/audit", "Legal / legitimate use"],
                  ["Access data (profile, permissions, sessions)", "System", "Security & continuity", "Legitimate use / contract"],
                  ["Telemetry/logs (device, performance, errors)", "System", "Reliability, diagnostics, security", "Legitimate use"],
                  ["Approx. geo", "System", "Experience optimization, security", "Legitimate use / consent if required"],
                  ["Support tickets", "You / Support", "Help & incident resolution", "Contract / legal obligation"],
                  ["Usage analytics (non-cookie)", "System", "Product improvement", "Legitimate use / consent if required"],
                ].map(([cat, src, purpose, basis], i) => (
                  <tr key={i} style={{ backgroundColor: i % 2 === 0 ? "#fff" : "#F5F7FA" }}>
                    <td style={{ padding: "8px 10px", borderBottom: "1px solid #E0E0E0", color: "#3C3C3C" }}>{cat}</td>
                    <td style={{ padding: "8px 10px", borderBottom: "1px solid #E0E0E0", color: "#3C3C3C" }}>{src}</td>
                    <td style={{ padding: "8px 10px", borderBottom: "1px solid #E0E0E0", color: "#3C3C3C" }}>{purpose}</td>
                    <td style={{ padding: "8px 10px", borderBottom: "1px solid #E0E0E0", color: "#3C3C3C" }}>{basis}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {section("Appendix B — Service Providers / Sub-processors (Summary)",
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ marginBottom: "6px" }}>
              <strong>Cloud hosting &amp; infrastructure:</strong> Microsoft Azure (India regions prioritized; cross-border safeguards
              applied only if needed via Schneider's BCR/SCC).
            </li>
            <li style={{ marginBottom: "6px" }}>
              <strong>Identity/IAM (if CIAM/SSO enabled):</strong> Schneider/LKEA centralized identity per corporate notices.
            </li>
          </ul>
        )}

        {/* Footer */}
        <div style={{ marginTop: "40px", paddingTop: "20px", borderTop: "1px solid #E0E0E0", textAlign: "center" }}>
          <button
            onClick={() => navigate('/')}
            style={{
              backgroundColor: "#005C8E",
              color: "#fff",
              border: "none",
              padding: "10px 36px",
              borderRadius: "25px",
              fontSize: "15px",
              cursor: "pointer",
            }}
          >
            Back to Login
          </button>
          <p style={{ marginTop: "16px", fontSize: "12px", color: "#9E9E9E" }}>
            © Lauritz Knudsen Electrical &amp; Automation (Schneider Electric India Pvt. Ltd.) — All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
